module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_kyoto-0c3c30217c8b4e13f72bb05cd983149c.jpg";